<template>
  <div class="points-settings">
    <el-container>
      <el-main>
        <div class="settings-wrapper">
          <div class="header">
            <h3>消费积分设置</h3>
            <el-switch
                v-model="pointsSettings.enabled"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="开启"
                inactive-text="关闭"
                @change="handleTogglePoints"
            ></el-switch>
          </div>

          <el-form :model="pointsSettings" label-width="200px" :disabled="!pointsSettings.enabled">

            <!-- 基础积分规则 -->
            <el-collapse v-model="activeNames">
              <el-collapse-item title="基础积分规则" name="1">
                <el-form-item label="消费金额兑换积分">
                  <el-input-number
                      v-model="pointsSettings.amountPerPoint"
                      :min="1"
                      :max="50"
                      :step="1"
                      controls-position="right"
                  ></el-input-number>
                  <span class="form-tip">元 = 1积分（建议：1~50元）</span>
                </el-form-item>

                <el-form-item label="积分有效期">
                  <el-input-number
                      v-model="pointsSettings.expiryDays"
                      :min="30"
                      :max="730"
                      :step="30"
                      controls-position="right"
                  ></el-input-number>
                  <span class="form-tip">天（建议：30~730天）</span>
                </el-form-item>

                <el-form-item label="积分兑换现金比例">
                  <el-input-number
                      v-model="pointsSettings.pointsPerYuan"
                      :min="50"
                      :max="500"
                      :step="10"
                      controls-position="right"
                  ></el-input-number>
                  <span class="form-tip">积分 = 1元（建议：50~500积分）</span>
                </el-form-item>
              </el-collapse-item>

              <!-- 特殊日期积分倍数 -->
              <el-collapse-item title="特殊日期积分倍数" name="2">
                <el-table :data="pointsSettings.specialDays" border style="width: 100%">
                  <el-table-column prop="date" label="日期" width="180">
                    <template slot-scope="scope">
                      <el-date-picker
                          v-model="scope.row.date"
                          type="date"
                          placeholder="选择日期"
                          value-format="yyyy-MM-dd"
                          style="width: 100%"
                      ></el-date-picker>
                    </template>
                  </el-table-column>
                  <el-table-column prop="multiplier" label="积分倍数" width="150">
                    <template slot-scope="scope">
                      <el-input-number
                          v-model="scope.row.multiplier"
                          :min="1"
                          :max="5"
                          :step="0.5"
                          controls-position="right"
                          style="width: 100%"
                      ></el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                      <el-button
                          type="danger"
                          icon="el-icon-delete"
                          circle
                          size="mini"
                          @click="removeSpecialDay(scope.$index)"
                      ></el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-button
                    type="primary"
                    icon="el-icon-plus"
                    @click="addSpecialDay"
                    plain
                    style="margin-top: 10px;"
                >添加特殊日期</el-button
                >
              </el-collapse-item>

              <!-- 积分使用限制 -->
              <el-collapse-item title="积分使用上限" name="3">
                <el-form-item label="单笔订单最多使用积分">
                  <el-slider
                      v-model="pointsSettings.maxUsagePercentage"
                      :min="0"
                      :max="100"
                      :step="5"
                      show-input
                  ></el-slider>
                  <span class="form-tip">百分比（建议不超过 50%）</span>
                </el-form-item>
              </el-collapse-item>

              <!-- 会员等级积分要求 -->
              <el-collapse-item title="会员等级积分要求" name="4">
                <el-table :data="pointsSettings.memberLevels" border style="width: 100%">
                  <el-table-column prop="level" label="等级" width="100">
                    <template slot-scope="scope">
                      <el-input v-model.number="scope.row.level" />
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="等级名称" width="150">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.name" />
                    </template>
                  </el-table-column>
                  <el-table-column prop="requiredPoints" label="所需积分" width="150">
                    <template slot-scope="scope">
                      <el-input-number
                          v-model="scope.row.requiredPoints"
                          :min="0"
                          :step="100"
                          controls-position="right"
                          style="width: 100%"
                      ></el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column prop="discount" label="等级折扣" width="150">
                    <template slot-scope="scope">
                      <el-input-number
                          v-model="scope.row.discount"
                          :min="0.1"
                          :max="1"
                          :step="0.05"
                          controls-position="right"
                          style="width: 80%"
                      ></el-input-number>
                      <span style="margin-left: 5px;">折</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                      <el-button
                          type="danger"
                          icon="el-icon-delete"
                          circle
                          size="mini"
                          @click="removeMemberLevel(scope.$index)"
                      ></el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-button
                    type="primary"
                    icon="el-icon-plus"
                    @click="addMemberLevel"
                    plain
                    style="margin-top: 10px;"
                >添加会员等级</el-button
                >
              </el-collapse-item>
            </el-collapse>

            <el-form-item style="margin-top: 30px;">
              <el-button type="success" icon="el-icon-check" @click="saveSettings" round>保存设置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'PointsSettings',
  props: {
    shop: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      activeNames: ['1', '2', '3', '4'],
      pointsSettings: JSON.parse(
          JSON.stringify(this.shop.pointsSettings || {
            enabled: false,
            amountPerPoint: 10, // 10元=1积分
            expiryDays: 365, // 积分有效期365天
            pointsPerYuan: 100, // 100积分=1元
            maxUsagePercentage: 50, // 单笔订单最多使用50%积分
            specialDays: [
              { date: '2025-12-25', multiplier: 2 }, // 圣诞节双倍积分
              { date: '2025-01-01', multiplier: 1.5 } // 元旦1.5倍积分
            ],
            memberLevels: [
              { level: 1, name: '普通会员', requiredPoints: 0, discount: 1 },
              { level: 2, name: '白银会员', requiredPoints: 1000, discount: 0.95 },
              { level: 3, name: '黄金会员', requiredPoints: 5000, discount: 0.9 },
              { level: 4, name: '钻石会员', requiredPoints: 10000, discount: 0.85 }
            ]
          })
      )
    }
  },
  methods: {
    handleTogglePoints(enabled) {
      this.$confirm(`确定要${enabled ? '开启' : '关闭'}消费积分功能吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.pointsSettings.enabled = enabled
        this.$message.success(`消费积分功能已${enabled ? '开启' : '关闭'}`)
      }).catch(() => {
        this.pointsSettings.enabled = !enabled
      })
    },
    addSpecialDay() {
      this.pointsSettings.specialDays.push({
        date: '',
        multiplier: 1
      })
    },
    removeSpecialDay(index) {
      this.pointsSettings.specialDays.splice(index, 1)
    },
    addMemberLevel() {
      const maxLevel = Math.max(...this.pointsSettings.memberLevels.map(l => l.level), 0)
      this.pointsSettings.memberLevels.push({
        level: maxLevel + 1,
        name: '',
        requiredPoints: 0,
        discount: 1
      })
    },
    removeMemberLevel(index) {
      if (this.pointsSettings.memberLevels.length > 1) {
        this.pointsSettings.memberLevels.splice(index, 1)
      } else {
        this.$message.warning('至少保留一个会员等级')
      }
    },
    saveSettings() {
      // 验证会员等级是否逐级递增
      for (let i = 1; i < this.pointsSettings.memberLevels.length; i++) {
        const prev = this.pointsSettings.memberLevels[i - 1]
        const curr = this.pointsSettings.memberLevels[i]
        if (curr.requiredPoints <= prev.requiredPoints) {
          this.$message.error('会员等级所需积分必须逐级递增')
          return
        }
      }

      // 验证特殊日期是否完整
      const invalidDate = this.pointsSettings.specialDays.some(day => !day.date)
      if (invalidDate) {
        this.$message.error('请填写完整的特殊日期')
        return
      }

      // 验证是否有重复日期
      const dates = this.pointsSettings.specialDays.map(d => d.date)
      const hasDuplicate = new Set(dates).size !== dates.length
      if (hasDuplicate) {
        this.$message.error('特殊日期不能重复')
        return
      }

      this.$emit('save', this.pointsSettings)
    }
  }
}
</script>

<style scoped>
.points-settings {
  background-color: #f9f9f9;
  padding: 20px;
}

.settings-wrapper {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.form-tip {
  color: #999;
  font-size: 12px;
  margin-left: 10px;
}

.el-table {
  margin-top: 10px;
}

.el-slider {
  width: 80%;
  margin-right: 20px;
}

.el-collapse {
  background-color: #f9f9f9;
  border: none;
}

.el-collapse-item__header {
  background-color: #f5f7fa;
  border-radius: 6px;
  padding-left: 10px;
  font-weight: bold;
}
</style>